import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

document.addEventListener('DOMContentLoaded', () => {
	for (const carousel of document.querySelectorAll('.swiper.customer-highlights')) {
		const wrapper = carousel.closest('.customer-highlights-carousel');

		const swiper = new Swiper(carousel, {
			modules: [Navigation, Pagination],
			slidesPerView: 1,
			spaceBetween: 24,
			grabCursor: true,
			loop: true,

			navigation: {
				prevEl: wrapper.querySelector('[data-customer-highlight-prev]'),
				nextEl: wrapper.querySelector('[data-customer-highlight-next]'),
			},

			/* Dots are styled to only show on mobile, where a single slide is
			   visible at a time; above that the arrows drive the multi-up view */
			pagination: {
				el: wrapper.querySelector('[data-customer-highlight-pagination]'),
				clickable: true,
			},

			breakpoints: {
				1230: {
					slidesPerView: 4,
				},
				869: {
					slidesPerView: 3,
				},
				600: {
					slidesPerView: 2,
				},
			},
		});

		const switchToTab = target => {
			if (target) {
				wrapper.tabsInstance?.switchToTab(target);
			}
		};

		/* The cardless default highlight (if any) is shown until the visitor
		   starts cycling the carousel */
		const defaultTarget = wrapper.querySelector('[data-default-tab]')?.id;
		let hasNavigated = false;

		/* Bound after init so any initial slideChange isn't counted as navigation.
		   Once the visitor cycles, the leftmost (active) slide takes over as the
		   info shown, and the active-slide styling is enabled via has-navigated */
		swiper.on('slideChange', () => {
			hasNavigated = true;
			carousel.classList.add('has-navigated');
			switchToTab(swiper.slides[swiper.activeIndex]?.dataset.target);
		});

		/* Hovering a card previews its info (via the is-hover tabs); when the
		   pointer leaves the carousel, restore either the active slide's info
		   or the default highlight if the carousel hasn't been cycled yet */
		carousel.addEventListener('mouseleave', () => {
			switchToTab(hasNavigated ? swiper.slides[swiper.activeIndex]?.dataset.target : defaultTarget);
		});
	}
});
